<template>
  <div>
    <header class="c-header">
      <div class="c-header__title">
        <div class="c-header__title__logo">
          <router-link
            :to="{
              name: 'top',
              params: { mc_code: mcCode },
            }"
          >
            <img src="/mc/assets/img/common/logo.png" alt="MC" />
          </router-link>
        </div>
        <div class="c-header__title__text">
          <router-link
            :to="{
              name: 'top',
              params: { mc_code: mcCode },
            }"
            v-if="this.mansion != null"
          >
            {{ this.mansion.name }}
          </router-link>
        </div>
      </div>
      <div class="c-header__user">
        <router-link
          :to="{
            name: 'mypage',
            params: { mc_code: mcCode },
          }"
        >
          <p class="c-header__user__text">{{ roomNo }}号室</p>
          <p class="_user-resident" id="_user-resident"></p>
        </router-link>
      </div>
      <div class="c-header__spMenuButton">
        <img src="/mc/assets/img/common/icon-spMenu.png" alt="" />
      </div>
      <!-- <a class="drawr-handle">
        <span></span>
        <span></span>
        <span></span>
      </a> -->
    </header>
    <div class="c-header__spOnlyHeaderSpace"></div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    roomNo: String,
  },
};
</script>

<style scoped></style>
